module.exports = __webpack_public_path__ + "img/cu.41346d9a.svg";